import * as yup from 'yup';

export const DESC_MAX_CHARACTER_LIMIT = 250;

const OpenToSchema = () =>
  yup.object().shape({
    investingInStartups: yup.boolean(),
    investingInStartupsDesc: yup.string().when('investingInStartups', (value) => {
      if (value) {
        return yup
          .string()
          .max(DESC_MAX_CHARACTER_LIMIT, `Must not exceed ${DESC_MAX_CHARACTER_LIMIT} characters`);
      }
    }),
    hiring: yup.boolean(),
    hiringDesc: yup.string().when('hiring', (value) => {
      if (value) {
        return yup
          .string()
          .max(DESC_MAX_CHARACTER_LIMIT, `Must not exceed ${DESC_MAX_CHARACTER_LIMIT} characters`);
      }
    }),
    findingNewJob: yup.boolean(),
    findingNewJobDesc: yup.string().when('findingNewJob', (value) => {
      if (value) {
        return yup
          .string()
          .max(DESC_MAX_CHARACTER_LIMIT, `Must not exceed ${DESC_MAX_CHARACTER_LIMIT} characters`);
      }
    }),
    providingServices: yup.boolean(),
    providingServicesDesc: yup.string().when('providingServices', (value) => {
      if (value) {
        return yup
          .string()
          .max(DESC_MAX_CHARACTER_LIMIT, `Must not exceed ${DESC_MAX_CHARACTER_LIMIT} characters`);
      }
    }),
  });

export default OpenToSchema;
